module.exports = __webpack_public_path__ + "eb1e4c0891a093f2c778ee4a6abb8b01.fbx";